import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger } from "@/components/ui/select";

const NONE = "__none__";

// Contextual "Assigned To" for a person-linked task: the Person themself (even without a login), their
// authorized support team and explicitly connected agency people. Search stays inside that server-side pool.
export function AssigneeSelect({ personId, assigneeId, assigneePersonId, onChange, noneLabel = "Unassigned", testId = "task-assignee-select" }) {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (!personId) return;
    api.get("/task-assignees/options", { params: { person_id: personId } }).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [personId]);
  const shown = q.trim() ? items.filter((o) => (o.name || "").toLowerCase().includes(q.trim().toLowerCase())) : items;
  const value = assigneePersonId ? `person:${assigneePersonId}` : assigneeId ? (items.find((o) => o.user_id === assigneeId)?.key || `user:${assigneeId}`) : NONE;
  const current = items.find((o) => o.key === value);
  const groups = [...new Set(shown.map((o) => o.group))];
  const pick = (k) => {
    if (k === NONE) return onChange({ assignee_id: null, assignee_person_id: null });
    const o = items.find((x) => x.key === k);
    onChange(k.startsWith("person:") ? { assignee_id: o?.user_id || null, assignee_person_id: o.person_id } : { assignee_id: o.user_id, assignee_person_id: null });
  };
  return (
    <Select value={value} onValueChange={pick} onOpenChange={(o) => { if (!o) setQ(""); }}>
      <SelectTrigger data-testid={testId}><span className="truncate">{value === NONE ? noneLabel : current ? current.name : "Current assignee (outside this record's team)"}</span></SelectTrigger>
      <SelectContent className="bg-white max-h-72">
        <div className="p-1.5" onKeyDown={(e) => e.stopPropagation()}>
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search this record's team…" className="h-8 text-xs" data-testid={`${testId}-search`} />
        </div>
        <SelectItem value={NONE}>{noneLabel}</SelectItem>
        {groups.map((g) => (
          <SelectGroup key={g}>
            <SelectLabel className="text-[10px] tracking-wide text-slate-400">{g}</SelectLabel>
            {shown.filter((o) => o.group === g).map((o) => (
              <SelectItem key={o.key} value={o.key} data-testid={`assignee-opt-${o.key.replace(":", "-")}`}>
                <span className="font-medium">{o.name}</span> <span className="text-[11px] text-slate-500">· {o.label}</span>
              </SelectItem>))}
          </SelectGroup>
        ))}
        {value !== NONE && !current && <SelectItem value={value} disabled>Current assignee (outside this record's team)</SelectItem>}
      </SelectContent>
    </Select>
  );
}
